import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { StockService } from '../../services/stock.service';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Stock } from '../../model/Stock';
import { LoadService } from '../../services/load.service';
import { FilterUrlService } from '../../services/filter-url.service';
import { LocationService } from '../../services/location.service';

@Component({
  selector: 'entradas',
  templateUrl: './entradas.component.html',
  styleUrls: ['./entradas.component.css']
})
export class EntradasComponent implements OnInit {
  @ViewChild(ModalDirective) lgModal: ModalDirective;
  public load:number;
  public primeracarga:boolean;
  public stock_list:any;
  public links: any;
  public meta: any;
  public title = '';
  public signupForm: FormGroup;
  public item_to_update:number;
  public alert:string;
  public isopen:boolean;
  public settings = {
    columns:{
      created_at: { header: "Fecha de Ingreso", type:"date", tipo:"inputs_outputs", path:"attributes.created_at"},
      pallet_code: { header: "Pallet", type:"text", filter:{visible:true}},
      total: { header: "Total Cajas", type:"text",ignored:true },
      location:{
        header: "Ubicación",
        //cuando el elemento del filtro no es in input de texto, en este caso es un drop down
        type:"obj",
        // id_type: tipo de datos que se envia al backend, dd: dropdown
        filter: { visible:true,  id_type:'number',default:'asc', type:'dd' },
      },
      // location:{header: "Ubicación", type:"text",filter: { visible:true } },
      // position:{header: "Posición", type:"text",filter: { visible:true } }
      position:{header: "Posición", type:"text"}
    },
    actions:{
      edit: false,
      view: false,
      delete: false
    }
  };

  constructor(private _filter: FilterUrlService,private _stockService:StockService,private _loaddata: LoadService,private _location: LocationService) {
    this.stock_list = [];
    this.primeracarga = false;
    this.alert = '';
    this.isopen = false;
  }

  ngOnInit() {
    this._filter.filterFirstLoad(this.settings);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this._loaddata.loadChange(30);
    this.signupForm = new FormGroup({
      'fecha': new FormControl(null),
    });
    this.getUbicaciones();
    //this.loadData();
  }
/*carga los datos con respecto a un filtro en particular*/
  loadDataFiltered(filters){
    this.alert = 'Cargando información.'
    this.isopen = true;
    this._loaddata.loadChange(50);
    //console.log("filtros desde entradas ", filters);
    this._stockService.getDataFilteredInputs(filters).subscribe(
      (response:any) => {
        this.stock_list = response.data;
        this.stock_list = this.formatDate(this.stock_list);
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        if(error.status == 0){
          this.alert = 'Busqueda sin resultados.';
          this.onClosedAutomatic();
        }
        else{
          this.showError(error.error.error);
        }
      }
    );
  }
/*carga los datos al principio*/
  loadData(){
    this.alert = 'Cargando información.';
    this.isopen = true;
    this._loaddata.loadChange(60);
    this._stockService.getStockInputs().subscribe(
      (response:any) => {
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
        //console.log("respuesta de entradas ", response);

        this.stock_list = response.data;
        this.stock_list = this.formatDate(this.stock_list);
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = 'Carga finalizada';
        this.onClosedAutomatic();

      },
      (error:any) => {
        this.showError(error.error.error);
      }
    );
  }

/*obtiene las ubicaciones para los filtros*/
  getUbicaciones(){
    this.alert = 'Cargando ubicaciones.';
    this.isopen = true;
    this._loaddata.loadChange(60);

    this._location.getAll().subscribe(
      (response:any) => {
        let data = response.data;
        let location:string = "{";
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            location+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
          }
        }
        location = location.slice(0,-1);
        location+="}";
        this.settings.columns.location.filter['data'] = location;
        this.loadData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosed(): void {
      this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 3000);

  }


  /*formatea la fecha*/
  formatDate(stock_list:any){
    for(let entrada of stock_list){
      let fecha = entrada.attributes.created_at.date;
      let fechArray = fecha.split(' ');
      let fecha2 = fechArray[0];
      let fechArray2 = fecha2.split('-');


      entrada.attributes.created_at = fechArray2[2]+'-'+fechArray2[1]+'-'+fechArray2[0];
    }
    return stock_list;
  }

/*actualiza la información de la paginación*/
  updateData(data:any){
    this.stock_list = data;
    this.stock_list = this.formatDate(this.stock_list);
    this.onClosedAutomatic();
  }

  printForm(){

  }

  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
  }

/**
 * carga la informacion de una fila en el formulario
 * @param index indice de la fila
 */
  showViewForm(index):void {
    this.showChildModal();
  }

  showChildModal(): void {
    this.lgModal.show();
  }

  hideChildModal(): void {
    this.lgModal.hide();
  }

  handler(type: string, $event: ModalDirective) {
    if (type === 'onHide'){
    }
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/entradas/entradas.component.ts